import React, { Component } from 'react';
import Barcode from 'react-barcode';
import QRCode from 'qrcode.react';
import moment from 'moment';

class Congrats extends Component {
  constructor(props) {
    super(props);

    let storageState = {};
    if (localStorage.logo && localStorage.logo !== 'undefined') {
      storageState.logo = localStorage.logo;
    }
    if (localStorage.secondRedeemedLogo && localStorage.secondRedeemedLogo !== 'undefined') {
      storageState.logo2 = localStorage.secondRedeemedLogo;
    }
    if (localStorage.barcode && localStorage.barcode !== 'undefined') {
      storageState.barcode = localStorage.barcode;
    }
    if (localStorage.qrCode && localStorage.qrCode !== 'undefined') {
      storageState.qrCode = localStorage.qrCode;
    }
    if (localStorage.promoCode && localStorage.promoCode !== 'undefined') {
      storageState.promoCode = localStorage.promoCode;
    }
    if(localStorage.downloadLinks && localStorage.downloadLinks !== 'undefined') {
      storageState.downloadLinks = localStorage.downloadLinks;
    }
    if(localStorage.androidDownloadLink && localStorage.androidDownloadLink !== 'undefined') {
      storageState.androidDownloadLink = localStorage.androidDownloadLink;
    }
    if(localStorage.iosDownloadLink && localStorage.iosDownloadLink !== 'undefined') {
      storageState.iosDownloadLink = localStorage.iosDownloadLink;
    }
    if(localStorage.thankYouImageAndLink && localStorage.thankYouImageAndLink !== 'undefined') {
      storageState.thankYouImageAndLink = localStorage.thankYouImageAndLink;
    }
    if(localStorage.thankYouImage && localStorage.thankYouImage !== 'undefined') {
      storageState.thankYouImage = localStorage.thankYouImage;
    }
    if(localStorage.thankYouImageLink && localStorage.thankYouImageLink !== 'undefined') {
      storageState.thankYouImageLink = localStorage.thankYouImageLink;
    }
    if (localStorage.fontTopPadding && localStorage.fontTopPadding !== 'undefined') {
      storageState.fontTopPadding = localStorage.fontTopPadding;
    }
    if (localStorage.fontBottomPadding && localStorage.fontBottomPadding !== 'undefined') {
      storageState.fontBottomPadding = localStorage.fontBottomPadding;
    }
    if (localStorage.fontLeftPadding && localStorage.fontLeftPadding !== 'undefined') {
      storageState.fontLeftPadding = localStorage.fontLeftPadding;
    }
    if (localStorage.fontRightPadding && localStorage.fontRightPadding !== 'undefined') {
      storageState.fontRightPadding = localStorage.fontRightPadding;
    }

    this.state = {
      date: null,
      logo: null,
      logo2: null,
      barcode: null,
      qrCode: null,
      promoCode: null,
      downloadLinks: false,
      androidDownloadLink: null,
      iosDownloadLink: null,
      thankYouImageAndLink: false,
      thankYouImage: null,
      thankYouImageLink: null,
      fontTopPadding: null,
      fontBottomPadding: null,
      fontLeftPadding: null,
      fontRightPadding: null,
      ...storageState
    };
  }

  setTime() {
    const date = new Date();
    this.setState({
      date: date
    });
  }

  componentWillMount() {
    this.setTime();
  }

  componentDidMount() {
    this.timmerID = window.setInterval(function () {
      this.setTime();
    }.bind(this), 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.timmerID);
  }

  render() {
    const barcode = this.state.barcode;
    const qrCode = this.state.qrCode;
    const logo = this.state.logo;
    const logo2 = this.state.logo2;
    const promoCode = this.state.promoCode;
    const downloadLinks = this.state.downloadLinks == "true" ? true : false;;
    const androidDownloadLink = this.state.androidDownloadLink;
    const iosDownloadLink = this.state.iosDownloadLink;
    const thankYouImageAndLink = this.state.thankYouImageAndLink == "true" ? true : false;;
    const thankYouImage = this.state.thankYouImage;
    const thankYouImageLink = this.state.thankYouImageLink;

    const fontTopPadding = 0 + Number(this.state.fontTopPadding);
    const fontBottomPadding = 0 + Number(this.state.fontBottomPadding);
    const fontLeftPadding = 0 + Number(this.state.fontLeftPadding);
    const fontRightPadding = 0 + Number(this.state.fontRightPadding);

    return (
      <div className="genericAppInner">
        <div className="page altBg">
          <div className="verticalWrap contentWrap">
            <div className="genericInnerWrap">
              {barcode !== undefined && barcode !== null && barcode != "null" &&
                <div className="barcode">
                  <Barcode value={barcode} height={75} />
                </div>
              }
              {qrCode !== undefined && qrCode !== null && qrCode != "null" &&
                <div className="qrCode">
                  <QRCode value={qrCode} includeMargin='true' size={192}/>
                </div>
              }
              <h1
                className="thanks"
                style={{
                  padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                }}
              >
                Thank You
              </h1>
              <div>
                { logo2 !== null && logo2 !== 'null' &&
                  <img src={logo2} />
                }
                <img src={logo} />
              </div>
              {thankYouImageAndLink &&
                <div className="thankYouImage">
                  <a href={thankYouImageLink}>
                      <img src={thankYouImage} />
                  </a>
                </div>
              }
              {promoCode !== undefined && promoCode !== null && promoCode !== "null" &&
                <h2
                  className="promoCode topSpace"
                  style={{
                    padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                  }}
                >
                  {promoCode}
                </h2>
              }
              <div className="redeemedTimeStamp">
                <h3
                  className="timeStamp"
                  style={{
                    padding: fontTopPadding + 'px ' + fontRightPadding + 'px ' + fontBottomPadding + 'px ' + fontLeftPadding + 'px'
                  }}
                >
                  {moment(this.state.date).format('l LTS')}
                </h3>
                {downloadLinks &&
                  <div className="downloadLinks">
                    <a href={iosDownloadLink}>
                        <img className="ios" src="https://s3-us-west-2.amazonaws.com/contest.fanup.io/ios.png" alt="" />
                    </a>
                    <a href={androidDownloadLink}>
                        <img className="android" src="https://s3-us-west-2.amazonaws.com/contest.fanup.io/android.png" alt="" />
                    </a>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Congrats;



// WEBPACK FOOTER //
// ./src/components/Congrats.js